import { render, staticRenderFns } from "./FaultTreatment.vue?vue&type=template&id=a9207278&scoped=true"
import script from "./FaultTreatment.vue?vue&type=script&lang=js"
export * from "./FaultTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9207278",
  null
  
)

export default component.exports